import React from "react";
import {
  safe,
  asList,
  formatAddress,
  formatUKPhone,
  initialsFrom,
  cssColor,
  fmtMaybeDate,
  fmtMaybeMonthYear,
  statusColor,
  QUAL_GROUPS,
  pickTruthy,
  fmtDate,
} from "../../utils/formatters";
import { Chip, PostCard, Row } from "../../helperFunctions/HelperFunctions";

export const AdviserDetails = ({ details, loading, header }) => {
  return (
    <div className="smFeed">
      {loading ? (
        <div className="smLoading Content-Small">Loading profile…</div>
      ) : (
        <>
          <PostCard title="Contact">
            <div className="smGrid2">
              <Row
                label="Email"
                value={details.personalDetails?.emailAddress || header.email}
                href={`mailto:${details.personalDetails?.emailAddress || header.email}`}
              />
              <Row
                label="Mobile"
                value={formatUKPhone(details.personalDetails?.mobileTelephone)}
                href={`tel:${formatUKPhone(details.personalDetails?.mobileTelephone)}`}
              />
              <Row
                label="Home"
                value={formatUKPhone(details.personalDetails?.homeTelephone)}
                href={`tel:${formatUKPhone(details.personalDetails?.homeTelephone)}`}
              />
              <Row
                label="Office"
                value={formatUKPhone(details.personalDetails?.officeTelephone)}
                href={`tel:${formatUKPhone(details.personalDetails?.officeTelephone)}`}
              />
            </div>
          </PostCard>

          <PostCard title="Business address">
            <Row
              label="Address"
              value={formatAddress(header.businessAddress)}
            />
          </PostCard>

          <PostCard title="Current address">
            <Row
              label="Current address"
              value={details.personalDetails?.currentAddress}
            />
            <div className="smGrid2">
              <Row label="Town" value={details.personalDetails?.currentTown} />
              <Row
                label="County"
                value={details.personalDetails?.currentCounty}
              />
              <Row
                label="Postcode"
                value={details.personalDetails?.currentPostcode}
              />
              <Row
                label="Moving in date"
                value={details.personalDetails?.movingInDate}
                kind="monthYear"
              />
            </div>
          </PostCard>

          <PostCard title="Personal details">
            <div className="smGrid2">
              <Row
                label="Date of birth"
                value={fmtDate(details.personalDetails?.dob)}
                kind="date"
              />
              <Row
                label="Nationality at birth"
                value={details.personalDetails?.nationalityAtBirth}
              />
              <Row
                label="Town of birth"
                value={details.personalDetails?.townOfBirth}
              />
              <Row
                label="Country of birth"
                value={details.personalDetails?.countryOfBirth}
              />
              <Row
                label="Name change date"
                value={details.personalDetails?.nameChangeDate}
                kind="monthYear"
              />
              <Row
                label="Lived in UK since"
                value={details.personalDetails?.durationInUk}
                kind="monthYear"
              />
            </div>
          </PostCard>

          <PostCard title="Application details">
            <div className="smGrid2">
              <Row
                label="Applying as"
                value={
                  asList(details.applicationDetails?.applyingAs).join(", ") ||
                  "-"
                }
              />
              <Row
                label="Applying to join"
                value={details.applicationDetails?.applyingToJoin}
              />
              <Row
                label="Business permissions"
                value={
                  asList(details.applicationDetails?.businessAreas).join(
                    ", ",
                  ) || "-"
                }
              />
              <Row
                label="AR business permissions"
                value={
                  asList(details.applicationDetails?.ARBusinessAreas).join(
                    ", ",
                  ) || "-"
                }
              />
              <Row
                label="Trading style"
                value={details.applicationDetails?.tradingStyle}
              />
              <Row
                label="Referred business"
                value={
                  details.applicationDetails?.referredBusiness === true
                    ? "Yes"
                    : details.applicationDetails?.referredBusiness === false
                      ? "No"
                      : "-"
                }
              />
            </div>
          </PostCard>

          <PostCard title="Next of kin">
            <div className="smGrid2">
              <Row label="Name" value={details.nextOfKinDetails?.name} />
              <Row
                label="Relationship"
                value={details.nextOfKinDetails?.relationship}
              />
              <Row
                label="Email"
                value={details.nextOfKinDetails?.email}
                href={`mailto:${details.nextOfKinDetails?.email}`}
              />
              <Row
                label="Telephone"
                value={formatUKPhone(details.nextOfKinDetails?.telephone)}
                href={`tel:${formatUKPhone(details.nextOfKinDetails?.telephone)}`}
              />
              <Row label="Address" value={details.nextOfKinDetails?.address} />
              <Row label="Town" value={details.nextOfKinDetails?.town} />
              <Row label="County" value={details.nextOfKinDetails?.county} />
              <Row
                label="Postcode"
                value={details.nextOfKinDetails?.postcode}
              />
            </div>
          </PostCard>
        </>
      )}
    </div>
  );
};

export default AdviserDetails;
